import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PixHelpComponent } from '../../pix/help/help.component';
import { FAQ_LIST } from './faq.constant';

@Component({
	selector: 'app-limits-faq',
	templateUrl: './faq.component.html',
	styleUrls: ['./faq.component.styl'],
	encapsulation: ViewEncapsulation.None
})

export class LimitsFaqComponent implements OnInit {
	list = FAQ_LIST;

	constructor(public dialog: MatDialog) { }

	ngOnInit() {

	}

	public openHelpModal() : void {
		this.dialog.open(PixHelpComponent, {
			width: '500px',
		});
	}

}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/faq/faq.component.ts